import Repository from './Repository';
import { AxiosResponse } from 'axios';
import { RecipeProfileRowData } from '@/models/Reports/RecipeProfileRowData';

const resource = '/reports';

export default {
  getProfileReportData(
    recipeId: number,
    countryId: number,
    rounded: boolean
  ): Promise<AxiosResponse<RecipeProfileRowData[]>> {
    return Repository.get<RecipeProfileRowData[]>(
      `${resource}/ProfileReport?recipeId=${recipeId}&countryId=${countryId}&rounded=${rounded}`,
      { withCredentials: true }
    );
  }
};